export const ConversationParticipantType = {
  ADMIN: "admin",
  MEMBER: "member",
};
